import React from 'react';
import { Box } from '@mui/material';
import useMediaQuery from '@mui/material/useMediaQuery';

import { useThemeContext } from '../../contexts/ThemeContext';

const NotFoundPage: React.FC = () => {
  const { theme } = useThemeContext();
  const md = useMediaQuery(theme.breakpoints.up('sm'));

  return (
    <Box sx={{ display: 'flex', textAlign: 'center', py: 4 }}>
      <Box
        sx={{
          display: 'initial',
          flexDirection: 'column',
          alignItems: 'center',
          maxWidth: 800,
          margin: 'auto',
          mt: 4,
          justifyContent: 'center',
          height: '100vh',
          gap: '1rem',
        }}
      >
        <Box sx={{ minWidth: '81%', padding: '10px' }}>
          <h1>404 - Page Not Found</h1>
          <p>The page you're looking for doesn't exist.</p>
        </Box>
      </Box>
      {md && (
        <Box sx={{ maxWidth: '492px', maxHeight: '360px' }}>
          <img src="/images/login.png" alt="Login" style={{ maxWidth: '492px', maxHeight: '360px' }} />
        </Box>
      )}
    </Box>
  );
};

export default NotFoundPage;
